import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { RequirementSettings } from "@/features/settings/components/requirement-settings"
import { PageContent } from "@/components/common/page-content"
import { planQueries } from "@/queries/plan"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/requirements/"
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(planQueries.settings()),
  component: RequirementSettingsPage,
})

function RequirementSettingsPage() {
  return (
    <>
      <PageHeader title="Requirements" />
      <PageContent>
        <RequirementSettings />
      </PageContent>
    </>
  )
}
